export default __webpack_public_path__ + "static/media/AlignTop.787e951e.svg";